import { parseForm } from 'helpers/generalHelpers';
import { lookupMed } from 'helpers/medicationHelpers';
import moment from 'moment';
import React, { useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { addPrescriptionToDb } from 'store/localDb';
import { addPrescription } from 'store/storeValtio';


export default function AddPrescription() {
	console.log('AddPrescription');
	const params = useParams();
	console.log('MedDetails', params);
	const medId = params.id;
	const navigate = useNavigate();

	const [submitting, setSubmitting] = useState(false);
	const [errors, setErrors] = useState()
	const [submitError, setSubmitError] = useState()

	const prescription = {
		medicationId: medId,
		pharmacy: 'CVS',
		dateFilled: '09/12/2024',
		quantityFilled: 45,
		strength: '0.5 MG',
		maximumDailyDosage: 2
	}

	const med = useMemo(()=>lookupMed(medId),[medId]);

	function findFormErrors(vals)
	{
		setErrors(null);
		return false;
	}

	async function handleSubmit(e) {
		console.log('handleSubmit', e);
		e.preventDefault()

		// validate form data
		const formItems = e.target;
		console.log('formItems', formItems);
		var formVals = parseForm(formItems);
		console.log('formVals', formVals);

		// get our new errors
		const fe = findFormErrors(formVals)
		console.log('form errors: ', fe);
		if (fe) return;

		// No errors! Put any logic here for the form submission!
		setSubmitting(true);
		var fdf = formVals.dateFilled + 'T00:00:00.000'
		const mnt =  moment(fdf)
		const df = mnt.startOf('day').toISOString();
		console.log('df', fdf, mnt, df);
		const newPre = {
			medicationId: medId,
			pharmacy: formVals.pharmacy,
			dateFilled: df,
			quantityFilled: formVals.quantityFilled,
			strength: formVals.strength,
			dosage: formVals.dosage,
		}

		// add new prescription
		try {
			console.log('addPrescription', newPre);
			let result = await addPrescriptionToDb(newPre);
			console.log('addPrescription', result);
			addPrescription(newPre);
		} catch (error) {
			console.log('addPrescription error', error);
			setSubmitError(error.message);
			setSubmitting(false);
			return;
		}

		setSubmitting(false);
		navigate(-1);
	}

	return (
		<div className='container w-full'>
			<div className='w-full pl-4 py-2 text-green-500 text-3xl font-bold'>
				{med.name}
			</div>
			<div className='bg-gray-100 px-2 tablet:px-8'>
				<div className='py-2 text-center text-xl font-extrabold text-gray-900'>
					Please enter your prescription data
				</div>

				<div className='mt-2 mx-auto w-full max-w-md'>
					{(errors || submitError) && (
						<div
							className='bg-red-100 rounded-lg py-5 px-6 mb-3 text-base text-red-700'
							role='alert'
						>
							{errors}{submitError}
						</div>
					)}

					<div className='bg-white py-6 px-6 shadow rounded-lg'>
						<form className='mb-0 space-y-4' onSubmit={handleSubmit}>
							<div>
								<label htmlFor='pharmacy' className='block text-sm font-medium text-gray-700' > Pharmacy </label>
								<div className='mt-1'>
									<input
										className='formText'
										id='pharmacy'
										name='pharmacy'
										type='text'
										defaultValue={prescription.pharmacy}
									/>
								</div>
							</div>
							<div>
								<label htmlFor='dateFilled' className='block text-sm font-medium text-gray-700' > Date Filled </label>
								<div className='mt-1'>
									<input
										className='formText'
										id='dateFilled'
										name='dateFilled'
										type='date'
										required
										defaultValue={prescription.dateFilled}
									/>
								</div>
							</div>
							<div>
								<label htmlFor='quantityFilled' className='block text-sm font-medium text-gray-700' > Quantity Filled </label>
								<div className='mt-1'>
									<input
										className='formText'
										id='quantityFilled'
										name='quantityFilled'
										type='number'
										required
										defaultValue={prescription.quantityFilled}
									/>
								</div>
							</div>
							<div>
								<label htmlFor='strength' className='block text-sm font-medium text-gray-700' > Strength </label>
								<div className='mt-1'>
									<input
										className='formText'
										id='strength'
										name='strength'
										type='text'
										required
										defaultValue={prescription.strength}
									/>
								</div>
							</div>
							<div>
								<label htmlFor='dosage' className='block text-sm font-medium text-gray-700' > Maximum Daily Dosage </label>
								<div className='mt-1'>
									<input
										className='formText'
										id='dosage'
										name='dosage'
										type='number'
										required
										defaultValue={prescription.maximumDailyDosage}
									/>
								</div>
							</div>
							<div className='flex justify-between'>
								<button type='submit' disabled={submitting} className='okBtn float-left'>Save Prescription</button>
								<button onClick={() => navigate(-1)} type='button' className='cancelBtn float-right'>Cancel</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}

